var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-menu " },
    [
      _c(
        "el-menu",
        {
          attrs: { collapse: "", mode: "horizontal", "menu-trigger": "hover" }
        },
        [
          _c(
            "el-submenu",
            { attrs: { index: "1", "popper-class": "navbar-menu-popper" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c("svg-icon", {
                    staticStyle: { "font-size": "20px", "margin-left": "0" },
                    attrs: { "icon-class": "top_menu" }
                  })
                ],
                1
              ),
              !_vm.isSalesForSzFs
                ? _c(
                    "el-submenu",
                    {
                      attrs: {
                        index: "1-1",
                        "popper-append-to-body": "",
                        "popper-class": "navbar-menu-popper"
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Menu.HelpCenter")) + " ")
                      ]),
                      _c(
                        "el-menu-item",
                        { on: { click: _vm.showOperationGuide } },
                        [_vm._v(_vm._s(_vm.$t("Menu.SystemOperationGuidance")))]
                      ),
                      _c("el-menu-item", { on: { click: _vm.showInitGuide } }, [
                        _vm._v(_vm._s(_vm.$t("Menu.InitializeBoot")))
                      ])
                    ],
                    2
                  )
                : _vm._e(),
              _c("el-menu-item", { on: { click: _vm.refreshCache } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reflush")))
              ]),
              _c("el-menu-item", { on: { click: _vm.showSettingAndTools } }, [
                _vm._v(" " + _vm._s(_vm.$t("Menu.SettingsAndTools")) + " ")
              ]),
              _vm.sysPopUpMenuList.indexOf("tweet") > -1 && !_vm.isSalesForSzFs
                ? _c("el-menu-item", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://e.weibo.com/walltechsystem/profile/",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.Weibo")))]
                    )
                  ])
                : _vm._e(),
              !_vm.isSalesForSzFs
                ? _c(
                    "el-menu-item",
                    {
                      on: {
                        click: function($event) {
                          _vm.logInfoDrawerVisible = true
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Menu.LogInformation")) + " ")]
                  )
                : _vm._e(),
              !_vm.isSalesForSzFs
                ? _c("el-menu-item", { on: { click: _vm.unBindWeChat } }, [
                    _vm._v(" " + _vm._s(_vm.$t("Menu.UnbindWeChat")) + " ")
                  ])
                : _vm._e(),
              _vm.sysPopUpMenuList.indexOf("sysInfo") > -1 &&
              !_vm.isSalesForSzFs
                ? _c(
                    "el-menu-item",
                    {
                      on: {
                        click: function($event) {
                          _vm.sysInfoDialogVisible = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Menu.SystemInformation")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _c("el-menu-item", { on: { click: _vm.logout } }, [
                _vm._v(" " + _vm._s(_vm.$t("Menu.SignOut")) + " ")
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("init-guide-dialog", {
        attrs: { visible: _vm.initGuideVisible },
        on: {
          "update:visible": function($event) {
            _vm.initGuideVisible = $event
          }
        }
      }),
      _c("setting-and-tools", {
        attrs: { visible: _vm.innerSettingAndToolsVisible },
        on: {
          "update:visible": function($event) {
            _vm.innerSettingAndToolsVisible = $event
          }
        }
      }),
      _c("log-info-drawer", {
        attrs: { visible: _vm.logInfoDrawerVisible },
        on: {
          "update:visible": function($event) {
            _vm.logInfoDrawerVisible = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Menu.SystemInformation"),
            visible: _vm.sysInfoDialogVisible,
            width: "500px",
            "append-to-body": ""
          },
          on: {
            close: function($event) {
              _vm.sysInfoDialogVisible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "div",
                { staticStyle: { height: "181px", "text-align": "center" } },
                [
                  _c("img", {
                    staticStyle: { height: "120px", "margin-top": "40px" },
                    attrs: { src: _vm.sysInfoLogo }
                  })
                ]
              ),
              _c("p", [_vm._v("Build:25.01.13.125")]),
              _c("p", [_vm._v(_vm._s(_vm.copyright))]),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "primary",
                    href: "http://www.walltechsystem.cn",
                    target: "_blank"
                  }
                },
                [_vm._v("http://www.walltechsystem.cn")]
              )
            ],
            1
          )
        ]
      ),
      _c("iframe", {
        staticStyle: { display: "none" },
        attrs: { id: "qq-frame", name: "qq-frame", src: _vm.qqUrl }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }